export default __webpack_public_path__ + "static/einhornalone_collab-ccd860719f5e7c5f746a28b772cfd1dc.svg";